/** This list was extracted on 20 dec 2020 and contains the list of Physics Nobel Laureates
 *
 * @see https://en.wikipedia.org/wiki/List_of_Nobel_laureates_in_Physics
 */
export const names = [
    'Wilhelm Röntgen',
    'Hendrik Lorentz',
    'Pieter Zeeman',
    'Antoine Henri Becquerel',
    'Pierre Curie',
    'Marie Skłodowska-Curie',
    'Lord Rayleigh',
    'Philipp Eduard Anton von Lenard',
    'Joseph John Thomson',
    'Albert Abraham Michelson',
    'Gabriel Lippmann',
    'Guglielmo Marconi',
    'Karl Ferdinand Braun',
    'Johannes Diderik van der Waals',
    'Wilhelm Wien',
    'Nils Gustaf Dalén',
    'Heike Kamerlingh-Onnes',
    'Max von Laue',
    'William Henry Bragg',
    'William Lawrence Bragg',
    'Charles Glover Barkla',
    'Max Planck',
    'Johannes Stark',
    'Charles Édouard Guillaume',
    'Albert Einstein',
    'Niels Bohr',
    'Robert Andrews Millikan',
    'Manne Siegbahn',
    'James Franck',
    'Gustav Hertz',
    'Jean Baptiste Perrin',
    'Arthur Holly Compton',
    'Charles Thomson Rees Wilson',
    'Owen Willans Richardson',
    'Louis Victor Pierre Raymond',
    'Chandrasekhara Venkata Raman',
    'Werner Heisenberg',
    'Erwin Schrödinger',
    'Paul Dirac',
    'James Chadwick',
    'Victor Francis Hess',
    'Carl David Anderson',
    'Clinton Joseph Davisson',
    'George Paget Thomson',
    'Enrico Fermi',
    'Ernest Lawrence',
    'Otto Stern',
    'Isidor Isaac Rabi',
    'Wolfgang Pauli',
    'Percy Williams Bridgman',
    'Edward Victor Appleton',
    'Patrick Maynard Stuart Blackett',
    'Hideki Yukawa',
    'Cecil Frank Powell',
    'John Douglas Cockcroft',
    'Ernest Thomas Sinton Walton',
    'Felix Bloch',
    'Edward Mills Purcell',
    'Frits Zernike',
    'Max Born',
    'Walther Bothe',
    'Willis Eugene Lamb',
    'Polykarp Kusch',
    'John Bardeen',
    'Walter Houser Brattain',
    'William Bradford Shockley',
    'Tsung-Dao Lee',
    'Chen-Ning Yang',
    'Pavel Alekseyevich Cherenkov',
    'Ilya Frank',
    'Igor Yevgenyevich Tamm',
    'Emilio Gino Segrè',
    'Owen Chamberlain',
    'Donald Arthur Glaser',
    'Robert Hofstadter',
    'Rudolf Ludwig Mössbauer',
    'Lev Davidovich Landau',
    'Eugene Paul Wigner',
    'Maria Goeppert-Mayer',
    'J. Hans D. Jensen',
    'Nicolay Gennadiyevich Basov',
    'Alexander Prokhorov',
    'Charles Hard Townes',
    'Richard Phillips Feynman',
    'Julian Schwinger',
    "Shin'ichirō Tomonaga",
    'Alfred Kastler',
    'Hans Albrecht Bethe',
    'Luis Walter Alvarez',
    'Murray Gell-Mann',
    'Hannes Olof Gösta Alfvén',
    'Louis Néel',
    'Dennis Gabor',
    'John Bardeen',
    'Leon Neil Cooper',
    'John Robert Schrieffer',
    'Leo Esaki',
    'Ivar Giaever',
    'Brian David Josephson',
    'Martin Ryle',
    'Antony Hewish',
    'Aage Bohr',
    'Ben Roy Mottelson',
    'Leo James Rainwater',
    'Burton Richter',
    'Samuel Chao Chung Ting',
    'Philip Warren Anderson',
    'Nevill Francis Mott',
    'John Hasbrouck Van Vleck',
    'Pyotr Leonidovich Kapitsa',
    'Arno Allan Penzias',
    'Robert Woodrow Wilson',
    'Sheldon Lee Glashow',
    'Abdus Salam',
    'Steven Weinberg',
    'James Watson Cronin',
    'Val Logsdon Fitch',
    'Nicolaas Bloembergen',
    'Arthur Leonard Schawlow',
    'Kai Manne Börje Siegbahn',
    'Kenneth G. Wilson',
    'Subrahmanyan Chandrasekhar',
    'William Alfred Fowler',
    'Carlo Rubbia',
    'Simon van der Meer',
    'Klaus von Klitzing',
    'Ernst Ruska',
    'Gerd Binnig',
    'Heinrich Rohrer',
    'Johannes Georg Bednorz',
    'Karl Alexander Müller',
    'Leon Max Lederman',
    'Melvin Schwartz',
    'Jack Steinberger',
    'Norman Foster Ramsey',
    'Hans Georg Dehmelt',
    'Wolfgang Paul',
    'Jerome I. Friedman',
    'Henry Way Kendall',
    'Richard E. Taylor',
    'Pierre-Gilles de Gennes',
    'Georges Charpak',
    'Russell Alan Hulse',
    'Joseph Hooton Taylor Jr.',
    'Bertram Brockhouse',
    'Clifford Glenwood Shull',
    'Martin Lewis Perl',
    'Frederick Reines',
    'David Morris Lee',
    'Douglas D. Osheroff',
    'Robert Coleman Richardson',
    'Steven Chu',
    'Claude Cohen-Tannoudji',
    'William Daniel Phillips',
    'Robert B. Laughlin',
    'Horst Ludwig Störmer',
    'Daniel Chee Tsui',
    "Gerard 't Hooft",
    'Martinus J. G. Veltman',
    'Zhores Ivanovich Alferov',
    'Herbert Kroemer',
    'Jack St. Clair Kilby',
    'Eric Allin Cornell',
    'Carl Edwin Wieman',
    'Wolfgang Ketterle',
    'Raymond Davis Jr.',
    'Masatoshi Koshiba',
    'Riccardo Giacconi',
    'Alexei Alexeyevich Abrikosov',
    'Vitaly Lazarevich Ginzburg',
    'Anthony James Leggett',
    'David J. Gross',
    'Hugh David Politzer',
    'Frank Wilczek',
    'Roy J. Glauber',
    'John L. Hall',
    'Theodor W. Hänsch',
    'John C. Mather',
    'George F. Smoot',
    'Albert Fert',
    'Peter Grünberg',
    'Makoto Kobayashi',
    'Toshihide Maskawa',
    'Yoichiro Nambu',
    'Charles K. Kao',
    'Willard S. Boyle',
    'George E. Smith',
    'Andre Geim',
    'Konstantin Novoselov',
    'Saul Perlmutter',
    'Brian P. Schmidt',
    'Adam G. Riess',
    'Serge Haroche',
    'David J. Wineland',
    'François Englert',
    'Peter Higgs',
    'Isamu Akasaki',
    'Hiroshi Amano',
    'Shuji Nakamura',
    'Takaaki Kajita',
    'Arthur B. McDonald',
    'David J. Thouless',
    'F. Duncan M. Haldane',
    'John M. Kosterlitz',
    'Rainer Weiss',
    'Kip Thorne',
    'Barry Barish',
    'Arthur Ashkin',
    'Gérard Mourou',
    'Donna Strickland',
    'James Peebles',
    'Michel Mayor',
    'Didier Queloz',
    'Roger Penrose',
    'Reinhard Genzel',
    'Andrea Ghez',
];
//# sourceMappingURL=data.js.map